import React from "react";

export const UserAccountContext = React.createContext({
  user: null,
  account: null,
  subscriptionStatus: null,
  onUpdateSubscription: () => {}
});



// WEBPACK FOOTER //
// ./src/contexts/userAccount.js